import { render, staticRenderFns } from "./Jonathan.vue?vue&type=template&id=5a3e2e49&scoped=true"
import script from "./Jonathan.vue?vue&type=script&lang=js"
export * from "./Jonathan.vue?vue&type=script&lang=js"
import style0 from "./Jonathan.vue?vue&type=style&index=0&id=5a3e2e49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e2e49",
  null
  
)

export default component.exports